/* eslint-disable no-underscore-dangle,@typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerSchema', [
    'DesignerBase',
    'DesignerSchemaField',

    function (DesignerBase, DesignerSchemaField) {
      function DesignerSchema() {
        this.id = null;
        this.name = null;
        this.valid = true;
        this.fields = [];
      }

      DesignerSchema.prototype = new DesignerBase();

      DesignerSchema.prototype.setData = function (data) {
        if (!data || !data.fields) return;

        const _this = this;

        this.fields = [];

        _.each(data.fields, function (field) {
          _this.addField(field);
        });
      };

      DesignerSchema.prototype.getData = function () {
        const fields = [];

        _.each(this.fields, function (field) {
          fields.push(field.getData());
        });

        return {
          valid: this.valid,
          fields,
        };
      };

      DesignerSchema.prototype.getSchema = function () {
        const fields = [];

        _.each(this.fields, function (field) {
          if (field.alias) fields.push({ name: field.alias });
          else if (field.projected_name) fields.push({ name: field.projected_name });
          else if (field.name) fields.push({ name: field.name });
        });

        return {
          valid: this.valid,
          fields,
        };
      };

      DesignerSchema.prototype.addField = function (data) {
        const field = new DesignerSchemaField(data);

        this.fields.push(field);
      };

      DesignerSchema.prototype.removeFieldByName = function (name) {
        _.remove(this.fields, { name });
      };

      DesignerSchema.prototype.removeAllFields = function () {
        this.fields = [];
      };

      return DesignerSchema;
    },
  ]);
})(window.angular);
